"use strict";

var _classCallCheck = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var prosemirror_utils_1 = require("prosemirror-utils");

var CommandMenu_1 = __importDefault(require("./CommandMenu"));

var BlockMenuItem_1 = __importDefault(require("./BlockMenuItem"));

var block_1 = __importDefault(require("../menus/block"));

var BlockMenu =
/*#__PURE__*/
function (_react_1$default$Comp) {
  _inherits(BlockMenu, _react_1$default$Comp);

  function BlockMenu() {
    var _this;

    _classCallCheck(this, BlockMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BlockMenu).apply(this, arguments));

    _this.clearSearch = function () {
      var _this$props$view = _this.props.view,
          state = _this$props$view.state,
          dispatch = _this$props$view.dispatch;
      var parent = prosemirror_utils_1.findParentNode(function (node) {
        return !!node;
      })(state.selection);

      if (parent) {
        dispatch(state.tr.insertText("", parent.pos, state.selection.to));
      }
    };

    return _this;
  }

  _createClass(BlockMenu, [{
    key: "render",
    value: function render() {
      return react_1.default.createElement(CommandMenu_1.default, Object.assign({}, this.props, {
        filterable: true,
        onClearSearch: this.clearSearch,
        renderMenuItem: function renderMenuItem(item, _index, options) {
          return react_1.default.createElement(BlockMenuItem_1.default, {
            onClick: options.onClick,
            selected: options.selected,
            icon: item.icon,
            title: item.title,
            shortcut: item.shortcut
          });
        },
        items: this.items
      }));
    }
  }, {
    key: "items",
    get: function get() {
      return block_1.default(this.props.dictionary);
    }
  }]);

  return BlockMenu;
}(react_1.default.Component);

exports.default = BlockMenu;